import { ProviderGroupControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author Atish Bagate
 * **/

interface Params {
  email?: string;
  xTENANTID?: string;
}

export const useAddProviderGroupEmailVerification = () =>
  useMutationWithLoading(async (params: Params) =>
    new ProviderGroupControllerApi(getConfigObject()).addProviderGroupEmail(
      { email: params?.email },
      params?.xTENANTID
    )
  );
